'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { Bell, Settings, Search } from 'lucide-react';

export default function DashboardHeader() {
  const [notifOpen, setNotifOpen] = useState(false);

  return (
    <header className="bg-white border-b border-border sticky top-0 z-30">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-10 h-16 flex items-center justify-between gap-4">
        {/* Logo */}
        <Link href="/" className="flex items-center gap-2 flex-shrink-0">
          <AppLogo size={30} />
          <span className="font-800 text-lg tracking-tight text-primary">RETURNI</span>
        </Link>

        {/* Search — desktop */}
        <div className="hidden md:flex items-center gap-2 bg-secondary rounded-full px-4 py-2 flex-1 max-w-sm">
          <Search size={15} className="text-muted-foreground" />
          <input
            type="text"
            placeholder="Search items, labels..."
            className="bg-transparent text-sm text-foreground placeholder:text-muted-foreground outline-none w-full"
          />
        </div>

        {/* Actions */}
        <div className="flex items-center gap-2">
          <div className="relative">
            <button
              onClick={() => setNotifOpen(!notifOpen)}
              className="relative w-9 h-9 rounded-full bg-secondary flex items-center justify-center hover:bg-muted transition-colors"
              aria-label="Notifications"
            >
              <Bell size={17} className="text-foreground" />
              <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full border border-white" />
            </button>

            {notifOpen && (
              <div className="absolute right-0 top-11 w-72 bg-white rounded-2xl shadow-card-hover border border-border z-50 overflow-hidden">
                <div className="px-4 py-3 border-b border-border flex items-center justify-between">
                  <span className="font-600 text-sm text-foreground">Notifications</span>
                  <span className="text-xs text-accent font-600">2 new</span>
                </div>
                <div className="flex flex-col">
                  {[
                    { title: 'Scan Alert', desc: 'North Face Jacket was scanned at 18:42', time: '2h ago', dot: 'bg-amber-500' },
                    { title: 'Recovery Update', desc: 'Suitcase recovery confirmed', time: '1d ago', dot: 'bg-accent' },
                  ]?.map((n, i) => (
                    <div key={`notif-${i}`} className="px-4 py-3 hover:bg-secondary transition-colors cursor-pointer border-b border-border last:border-0">
                      <div className="flex items-start gap-3">
                        <span className={`w-2 h-2 rounded-full ${n?.dot} mt-1.5 flex-shrink-0`} />
                        <div>
                          <p className="text-sm font-600 text-foreground">{n?.title}</p>
                          <p className="text-xs text-muted-foreground mt-0.5">{n?.desc}</p>
                          <p className="text-xs text-muted-foreground/60 mt-1">{n?.time}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <Link href="/" className="hidden sm:flex w-9 h-9 rounded-full bg-secondary items-center justify-center hover:bg-muted transition-colors" aria-label="Settings">
            <Settings size={17} className="text-foreground" />
          </Link>

          {/* Avatar */}
          <div className="w-9 h-9 rounded-full bg-gradient-to-br from-accent to-primary flex items-center justify-center flex-shrink-0">
            <span className="text-white font-700 text-sm">A</span>
          </div>
        </div>
      </div>
    </header>
  );
}